import type { ReactNode } from "react";
import styles from "./stockScreener.module.css";

export const NumericCell = ({
  children,
  title,
}: {
  children: ReactNode;
  title?: string;
}) => (
  <span className={styles.numericCell} title={title}>
    {children}
  </span>
);
